import { PropTypes } from 'prop-types'

const Button = ({ onClick, children, type, disabled }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      type={type}
      className={`w-full px-4 py-2 bg-primary text-white rounded-lg ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      {children}
    </button>
  )
}

Button.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['button', 'submit', 'reset']).isRequired,
  disabled: PropTypes.bool,
}

export default Button
